import { Button } from "antd";
import { cloneDeep } from "lodash";
import { PermissionHoc } from "../../HOC";
import { minutesInUnit } from "./constants";

export const checkTimeIfGreaterThan = (time1, time2, attempts) => {
  const time1Minutes = time1.value * minutesInUnit[time1.unit];
  const time2Minutes = time2.value * minutesInUnit[time2.unit] * attempts;
  return time1Minutes > time2Minutes;
};

export const PermissableSettingsButton = PermissionHoc(
  Button,
  "SETTINGS_WRITE_NOTIFICATIONS",
  { is_component: true, fallbackComponent: null }
);

export const updateCurrentUserDetailsFn = (
  values,
  virtual_account_settings
) => {
  const clonedNotificationSettings = cloneDeep(
    virtual_account_settings.notification_settings
  );

  const updatedNotificationSettings = {
    ...clonedNotificationSettings,
    email_enabled: values["instacollect_email_enabled"],
    emails: values["instacollect_emails"],
    sms_enabled: values["instacollect_sms_enabled"],
    phone_numbers: values["instacollect_phone_number"],
    webhook_enabled: values["webhook_enabled"],
    webhook_url: values["webhook_url"],
    transaction_capture_attempts: values["transaction_capture_attempts"],
    transaction_capture_attempt_interval:
      values["transaction_capture_attempt_interval"],
  };

  const clonedVirtualAccountSettings = cloneDeep(virtual_account_settings);
  const updatedVirtualAccountSettings = {
    ...clonedVirtualAccountSettings,
    enable_transaction_capture_flow: values["enable_transaction_capture_flow"],
    transaction_capture_attempt_interval_unit:
      values["transaction_capture_attempt_interval_unit"],
    auto_capture_tat_unit: values["auto_capture_tat_unit"],
    transaction_capture_tat_unit: values["transaction_capture_tat_unit"],
    transaction_capture_flow_type: values["transaction_capture_flow_type"],
    transaction_capture_tat: values["transaction_capture_tat"],
    auto_capture_tat: values["auto_capture_tat"],
    notification_settings: updatedNotificationSettings,
  };
  return updatedVirtualAccountSettings;
};

export const getInitialValues = (virtual_account_settings) => ({
  email_enabled:
    virtual_account_settings?.notification_settings?.email_enabled ?? false,
  instacollect_emails: Array.isArray(
    virtual_account_settings?.notification_settings?.emails
  )
    ? virtual_account_settings?.notification_settings?.emails
    : [],
  instacollect_sms_enabled:
    virtual_account_settings?.notification_settings?.sms_enabled ?? false,
  instacollect_phone_number: Array.isArray(
    virtual_account_settings?.notification_settings?.phone_numbers
  )
    ? virtual_account_settings?.notification_settings?.phone_numbers
    : [],
  webhook_enabled:
    virtual_account_settings?.notification_settings?.webhook_enabled ?? false,
  webhook_url:
    virtual_account_settings?.notification_settings?.webhook_url ?? "",
  transaction_capture_attempts:
    virtual_account_settings?.notification_settings
      ?.transaction_capture_attempts ?? "",
  transaction_capture_attempt_interval:
    virtual_account_settings?.notification_settings
      ?.transaction_capture_attempt_interval ?? "",
  enable_transaction_capture_flow:
    virtual_account_settings?.enable_transaction_capture_flow ?? false,
  transaction_capture_flow_type:
    virtual_account_settings?.transaction_capture_flow_type ?? [],
  transaction_capture_tat:
    virtual_account_settings?.transaction_capture_tat ?? "",
  auto_capture_tat: virtual_account_settings?.auto_capture_tat ?? "",
  transaction_capture_attempt_interval_unit:
    virtual_account_settings?.notification_settings?.transaction_capture_attempt_interval_unit ??
    "minutes",
  transaction_capture_tat_unit:
    virtual_account_settings?.transaction_capture_tat_unit ?? "hours",
});

export const calculateAutoTat = (
  noOfAttempts,
  attemptInterval,
  attemptIntervalUnit
) => {
  let val = noOfAttempts * attemptInterval;

  if (isNaN(val) || !noOfAttempts) val = "---";
  else val = `${val} ${attemptIntervalUnit}`;
  return val;
};
